import { useEffect } from "react";
import { useState } from "react";
import AddProduct from "../AddProduct";
import AddVariation from "../AddVariation";
import { useLocation, useParams } from "react-router-dom";
import { ProductServices } from "../../../services/products";
import { VariationService } from "../../../services/variations";
import ListVariations from "../ListVariations";
import { useAsync } from "../../../utils/hooks/useAsync";
import { AdminService } from "../utils";
import UploadImage from "../UploadImage";

const AddProductContainer = () => {
  const { run } = useAsync();
  const [product, setProduct] = useState<Product>({
    _id: "",
    title: "", // Forzet Larga Oro
    sku: "", // FLORO2023
    material: "",
    department: "", // Chains
    category: "", // Chains/Gold
    friendlyUrl: "", // www.rtabk.com/productos/forzet-largo-oro
    description: "", // El forzet largo es un modelo clasico...
    thumbnailUrl: "", // www.rtabak.com/images/....
    isCustom: false,
    tag: "",
  });
  const [variations, setVariations] = useState<Variation[]>();
  const [editProduct, setEditProduct] = useState<boolean>(false);
  const [updateVariations, setUpdateVariations] = useState<boolean>(false);
  const [editVariation, setEditVariation] = useState<boolean>(false);
  const [isSolid, setIsSolid] = useState<boolean>(false);
  const [manufacturingCost, setManufacturingCost] = useState<
    ManufacturingCost[]
  >([]);
  const route = useLocation();
  const { productFriendlyUrl } = useParams();

  useEffect(() => {
    if (updateVariations == true) {
      run(
        VariationService.getVariationsByProductId({
          id: product._id,
        }).then((data: { data: Variation[] }) => {
          setVariations(data.data);
        }),
      );
      setUpdateVariations(false);
    }
  }, [updateVariations]);

  useEffect(() => {
    if (route.pathname.includes("edit")) {
      setEditProduct(true);
      run(
        ProductServices.getProductByFriendlyUrl({
          friendlyUrl: productFriendlyUrl,
        }).then((data: { data: Product }) => {
          setProduct(data.data);
          (data.data.department == "chain" || "brazalete") &&
            !data.data.category.includes("pendant") &&
            !data.data.category.includes("rock") &&
            !data.data.category.includes("hollow") &&
            !data.data.category.includes("hoop") &&
            !data.data.category.includes("finding") &&
            !data.data.isCustom &&
            setIsSolid(true);
          run(
            VariationService.getVariationsByProductId({
              id: data.data._id,
            }).then((data: { data: Variation[] }) => {
              setVariations(data.data);
            }),
          );
        }),
      );
    } else {
      setProduct({
        _id: "",
        title: "", // Forzet Larga Oro
        sku: "", // FLORO2023
        material: "",
        department: "", // Chains
        category: "", // Chains/Gold
        friendlyUrl: "", // www.rtabk.com/productos/forzet-largo-oro
        description: "", // El forzet largo es un modelo clasico...
        thumbnailUrl: "", // www.rtabak.com/images/....
        isCustom: false,
        tag: "",
      });
      setEditProduct(false);
    }
    run(AdminService.getManufacturingCost()).then((r: any) => {
      setManufacturingCost(r.data);
    });
  }, [, route]);

  return (
    <>
      {product?._id ? (
        editProduct ? (
          product && !editVariation ? (
            <>
              {" "}
              <AddProduct
                productEdit={product}
                setState={setProduct}
                setEditVariation={setEditVariation}
                existVariations={
                  variations ? (variations?.length > 0 ? true : false) : false
                }
              />
              <UploadImage product={product} urlImage={product.thumbnailUrl} />
              {variations && (
                <>
                  <AddVariation
                    key={product._id}
                    product={product}
                    setState={setUpdateVariations}
                    manufacturingCost={manufacturingCost}
                    existingVariations={variations}
                  />
                  <ListVariations
                    Variations={variations}
                    manufacturingCost={manufacturingCost}
                    isSolid={isSolid}
                    department={product.department}
                    material={product.material}
                  />
                </>
              )}
            </>
          ) : (
            editVariation && (
              <>
                <AddVariation
                  key={product._id}
                  product={product}
                  setState={setUpdateVariations}
                  manufacturingCost={manufacturingCost}
                  existingVariations={variations}
                />
                {variations && (
                  <ListVariations
                    Variations={variations}
                    manufacturingCost={manufacturingCost}
                    isSolid={isSolid}
                    department={product.department}
                    material={product.material}
                  />
                )}
              </>
            )
          )
        ) : (
          <>
            <AddVariation
              key={product._id}
              product={product}
              setState={setUpdateVariations}
              manufacturingCost={manufacturingCost}
            />
          </>
        )
      ) : (
        <>
          <AddProduct setState={setProduct} productEdit={product} />
        </>
      )}
    </>
  );
};

export default AddProductContainer;
